module.exports = __webpack_public_path__ + "static/media/alert-triangle.b765a62b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/_styles/images/alert-triangle.svg
// module id = 1451
// module chunks = 1